module.exports = __webpack_public_path__ + "media/wonderful.c3d4a2e6.mp3";